const contract_address = "0xe4117B71f66Ea93F2be670c9b182e2Ca55B8AE53"

export default contract_address;